import {CREATE_NEW_CYCLE_START} from "../../types";

export const create_new_cycle = (payload) => ({
  type: CREATE_NEW_CYCLE_START,
  payload,
});
